// AI chat and the portal snapshot `contact.imageUrl` onto every message at write
// time, so a contact who had no photo back then stays photo-less forever.
export function resolveThreadActorImage(
	actorImage: string | null | undefined,
	contact?: { imageUrl?: string | null } | null,
): string | undefined {
	return actorImage || contact?.imageUrl || undefined
}
